import React from "react";
import { DraftDecoratorComponentProps } from "@sonder/editor/typings/editor";
import { StyledLink } from "./StyledLink";

const HTTP_PROTOCOL_CHECK = /^((https?:)?\/\/)/;
const getSafeLink = (rawLink: string) => {
  let safeLink = rawLink.trim();
  if (!HTTP_PROTOCOL_CHECK.test(rawLink)) safeLink = `//${safeLink}`;
  return safeLink;
};

export interface InlineLinkProps extends DraftDecoratorComponentProps {
  children: string;
}
export const InlineLink = ({ children, decoratedText }: InlineLinkProps) => {
  const safeLink = getSafeLink(decoratedText);
  return (
    <StyledLink
      href={safeLink}
      title={decoratedText}
      onClick={e => {
        e.preventDefault();
        window.open(safeLink, "_blank");
      }}
    >
      {children}
    </StyledLink>
  );
};
